import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { FuseqHeaders } from '../FuseQ/fuseq.headers'
export interface CronInfo {
  Id: number
  Name: string
  Cron?: string
  Frequency: string
  DurationMinutes?: number
  Status: string
  Hidden?: boolean
  Description?: string
  LauncherFile: string
  Enabled: boolean
  PM2ProcessName: string
  LastStart?: string
  LastStop?: string
  ErrorMessage?: string
  CreatedAt?: string
  UpdatedAt?: string
}

export interface PM2Status {
  cronName: string
  db: CronInfo
  pm2: {
    pm_id: number
    name: string
    status: string
    uptime: string
    restarts: number
    cpu: number
    memory: number
  }
}

export interface CronListResponse {
  cronsAvailable: CronInfo[]
  total: number
}

export interface CronStatusResponse {
  cronsStatus: PM2Status[]
  total: number
}

@Injectable({
  providedIn: 'root'
})
export class CronManagerService {
  private readonly baseUrl = `${environment.API_URL}/crons`

  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) {}

  listCrons (): Observable<CronListResponse> {
    return this.http.get<CronListResponse>(`${this.baseUrl}`, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getAllStatus (): Observable<CronStatusResponse> {
    return this.http.get<CronStatusResponse>(`${this.baseUrl}/status`, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getStatus (cronName: string): Observable<PM2Status> {
    return this.http.get<PM2Status>(`${this.baseUrl}/${cronName}/status`, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  startCron (cronName: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/${cronName}/start`, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  stopCron (cronName: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/${cronName}/stop`, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  restartCron (cronName: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/${cronName}/restart`, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  updateCronSchedule (cronName: string, cron: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/${cronName}/schedule`, { cron }, this.fuseqHeaders.setTokenHeaders('PUT'))
  }

  enableCron (cronName: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/${cronName}/enable`, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  disableCron (cronName: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/${cronName}/disable`, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  startAll (): Observable<any> {
    return this.http.post(`${this.baseUrl}/start-all`, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  stopAll (): Observable<any> {
    return this.http.post(`${this.baseUrl}/stop-all`, {}, this.fuseqHeaders.setTokenHeaders('POST'))
  }
}
